import { createContext, useContext, useState, useEffect } from 'react'
import { api } from '../services/api'
const AuthContext = createContext(null)
export function AuthProvider({ children }) {
    const [user, setUser] = useState(null)
    const [loading, setLoading] = useState(true)
    useEffect(() => {
        checkAuth()
    }, [])
    async function checkAuth() {
        try {
            const storedUser = localStorage.getItem('rdi_user')
            if (storedUser) {
                const userData = JSON.parse(storedUser)
                setUser(userData)

                // Refresh user data from server to pick up permission changes
                try {
                    const response = await api.get('/api/auth/me')
                    if (response.success && response.user) {
                        const refreshed = {
                            ...response.user,
                            token: userData.token
                        }
                        setUser(refreshed)
                        localStorage.setItem('rdi_user', JSON.stringify(refreshed))
                    }
                } catch (err) {
                    // If refresh fails (e.g. token expired), clear auth
                    console.error('Auth refresh failed:', err)
                    localStorage.removeItem('rdi_user')
                    setUser(null)
                }
            }
        } catch (error) {
            console.error('Auth check failed:', error)
            localStorage.removeItem('rdi_user')
            setUser(null)
        } finally {
            setLoading(false)
        }
    }
    async function login(username, password) {
        try {
            const response = await api.post('/api/auth/login', { username, password })
            if (response.success) {
                const userData = {
                    ...response.user,
                    token: response.token
                }
                setUser(userData)
                localStorage.setItem('rdi_user', JSON.stringify(userData))
                return { success: true }
            } else {
                return { success: false, message: response.message || 'Login failed' }
            }
        } catch (error) {
            return { success: false, message: 'Network error. Please try again.' }
        }
    }
    async function loginWithPin(pin) {
        try {
            const response = await api.post('/api/auth/pin-login', { pin })
            if (response.success) {
                const userData = {
                    ...response.user,
                    token: response.token
                }
                setUser(userData)
                localStorage.setItem('rdi_user', JSON.stringify(userData))
                return { success: true }
            } else {
                return { success: false, message: response.message || 'Invalid PIN' }
            }
        } catch (error) {
            return { success: false, message: 'Network error. Please try again.' }
        }
    }
    async function logout() {
        try {
            await api.post('/api/auth/logout')
        } catch (error) {
            console.error('Logout error:', error)
        } finally {
            setUser(null)
            localStorage.removeItem('rdi_user')
        }
    }
    const value = {
        user,
        loading,
        login,
        loginWithPin,
        logout,
        isSysAdmin: user?.isSysAdmin,
    }
    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    )
}
export function useAuth() {
    const context = useContext(AuthContext)
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider')
    }
    return context
}